import React, { useEffect, useState } from "react";
import Popup from "reactjs-popup";
import { Form, submission } from "@formio/react";
import { Link, useNavigate, useParams } from "react-router-dom";

const CreateForm = (props) => {
  const [objjnew, setobjjnew] = useState({});
  const Navigate = useNavigate();



const Saveaplnidintostorage=async ()=>
{
  const response = await fetch(`http://localhost:8080/auth/admin/realms/forms-flow-ai/users?briefRepresentation=true&first=0&max=100`, {
    method: "GET", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    // credentials: 'same-origin', // include, *same-origin, omit
    headers: {
      //   'Content-Type': 'application/json',

      Authorization: process.env.REACT_APP_5000_BEARER_TOKEN,
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: "follow", // manual, *follow, error
    referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    // body: JSON.stringify(data) // body data type must match "Content-Type" header
  })
    .then((data) => {
      data.json().then((data) => {
   
     

        // localStorage.setItem("applicationId",data.totalCount+1)
      
      });
    })
    .catch((err) => {
      console.log(err);
    });
}



  const myfunc = async (id, submission) => {

    const response = await fetch(
      `http://localhost:3001/form/${id}/submission`,
      {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        // credentials: 'same-origin', // include, *same-origin, omit
        headers: {
            'Content-Type': 'application/json',

          "x-jwt-token": process.env.REACT_APP_X_JWT_TOKEN,
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body:JSON.stringify(submission) // body data type must match "Content-Type" header
      }
    )
      .then((data) => {
        data.json().then((data) => {

          const changepayload = {
            formId: id,
            formUrl: `http://${process.env.REACT_APP_MY_CURRENT_IP}:3001/form/${id}/submission/${data._id}`,
            submissionId: data._id,
            webFormUrl: `http://${process.env.REACT_APP_MY_CURRENT_IP}:3000/form/${id}/submission/${data._id}`,
          };

     
          const createApicall = async () => {
            const response = await fetch(
              "http://localhost:5000/application/create",
              {
                method: "POST", // *GET, POST, PUT, DELETE, etc.
                mode: "cors", // no-cors, *cors, same-origin
                cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
                // credentials: 'same-origin', // include, *same-origin, omit
                headers: {
                    'Content-Type': 'application/json',
                    "Content-Length":312,

                    Authorization: process.env.REACT_APP_5000_BEARER_TOKEN,
                  // 'Content-Type': 'application/x-www-form-urlencoded',
                },
                redirect: "follow", // manual, *follow, error
                referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                body: JSON.stringify(changepayload), // body data type must match "Content-Type" header
              }
            )
              .then((data) => {
                data.json().then((data) => {
               
                });
              })
              .catch((err) => {
                console.log(err);
              });
          };
          createApicall();
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };



  const onSubmitHandler =async  (submission) => {
  

 

    await myfunc(props.bigArray._id, submission).then(()=>
    {
      // window.location.reload();

      // Navigate(`/Forms/${props.bigArray._id}`)
      // alert("New submission sent!!!")
    })
  

    
   
  };

  const myobject = props.bigArray;



  return (
    <div className="PopupModel">   
      <div ng-app="formApp" className="well mx-5">
        
        <Form form={myobject} onSubmit={onSubmitHandler}></Form>
      </div>
    </div>
  );
};

export default CreateForm;
